import { useQuery } from '@tanstack/react-query'
import { client, unwrap, type components } from '../../api'

/**
 * Dashboard types, generated from `openapi.yaml`. The hand-written interfaces
 * that used to live here are now the single source of truth in the spec
 * (`DashboardResponse`, `PainLog`, `DailyTracking`, `UserIdentity`).
 */
export type DashboardResponse = components['schemas']['DashboardResponse']
export type WeekLog = components['schemas']['PainLog']
export type TodayPain = components['schemas']['PainLog']
export type TodayTracking = components['schemas']['DailyTracking']
export type DashboardUser = components['schemas']['UserIdentity']

function localDateString() {
  return new Date().toLocaleDateString('en-CA')
}

export function useDashboard() {
  const today = localDateString()
  return useQuery({
    queryKey: ['patient', 'dashboard', today],
    queryFn: () =>
      unwrap(client.GET('/api/patient/dashboard', { params: { query: { today } } })),
    staleTime: 60_000,
  })
}
